import React, { Component, Fragment } from 'react';
import { bindActionCreators } from "redux"
import { connect } from "react-redux"
//import { render } from 'react-dom';
import ReactDatatable from '@ashvin27/react-datatable';
import { toastr } from "react-redux-toastr"
import Spinner from 'react-bootstrap/Spinner';
import { Modal } from "react-bootstrap";

import minhaImagemTodos from "../../../../src/figuras/exportar-todos.png";
import minhaImagemSelc from "../../../../src/figuras/exportar-selecinados.png";

import {
    getData
    , enviaRegistros
    , getDataTdsRevendas
} from "./prdCmbActions"
import { logout } from "./../../../auth/authActions"

class PrdCmb extends Component {
    constructor(props) {
        super(props)

        this.state = {
            arrayMarcados: []
            , arrayEnviar: []
            , todosArrayEnviar: []
            , SelPuxada: 0
            , booLerRecords: (this.props.codPuxada !== undefined && this.props.codPuxada !== null ? true : false)
            , MsgModal2: ""

        }

        if (this.props.codPuxada !== undefined && this.props.codPuxada !== null) {
            this.props.getData(this.props.codPuxada);
        }
        else {
            this.props.getDataTdsRevendas();

        }

        this.columns = [

            {
                key: "action1",
                text: "",
                className: "action1",
                width: 30,
                align: "center",
                sortable: false,
                cell: (record, index) => {
                    return (
                        <Fragment>
                            <input
                                name="isGoing"
                                type="checkbox"
                                onClick={this.selecionaCheck.bind(this, record, index)}
                            >
                            </input >
                        </Fragment>
                    );
                }
            },

            {
                key: "resellerID",
                text: "ResellerID",
                className: "resellerID",
                align: "left",
                sortable: true,
            },
            {
                key: "codCatIte",
                text: "CodCatIte",
                className: "codCatIte",
                align: "left",
                sortable: true
            },
            {
                key: "id",
                text: "Id",
                className: "id",
                align: "left",
                sortable: true
            },
            {
                key: "Status",
                text: "Status",
                className: "Status",
                align: "left",
                sortable: true
            },
            {
                key: "salesUnit",
                text: "Unit",
                className: "salesUnit",
                sortable: true,
                align: "center"
            },
            {
                key: "brand",
                text: "Brand",
                className: "brand",
                sortable: true,
                align: "right"
            },
            {
                key: "vatCode",
                text: "VatCode",
                className: "vatCode",
                sortable: true,
                align: "right"
            },

            // {
            //     key: "secondaryPackType",
            //     text: "SecondaryPackType",
            //     className: "secondaryPackType",
            //     sortable: true,
            //     align: "right"
            // },
            {
                key: "productGroup",
                text: "Group",
                className: "productGroup",
                sortable: true,
                align: "right"
            },

            {
                key: "materialType",
                text: "Material",
                className: "materialType",
                sortable: true,
                align: "left",
            },

            // {
            //     key: "productWeight",
            //     text: "ProductWeight",
            //     className: "productWeight",
            //     sortable: true,
            //     align: "left",
            // },

            {
                key: "productWeightUnit",
                text: "Unit",
                className: "productWeightUnit",
                sortable: true,
                align: "left",
            },

            // {
            //     key: "languageKey",
            //     text: "LanguageKey",
            //     className: "languageKey",
            //     sortable: true,
            //     align: "left",
            // },


            {
                key: "Value",
                text: "Value",
                className: "Value",
                sortable: true,
                align: "left",
                fontSize: "5"
            },
            // {
            //     key: "createdAtStaging",
            //     text: "CreatedAtStaging",
            //     className: "createdAtStaging",
            //     sortable: true,
            //     align: "left",
            // },
            {
                key: "updatedAtStaging",
                text: "UpdatedAtStaging",
                className: "updatedAtStaging",
                sortable: true,
                align: "left",
            },
            {
                key: "sendToHybrisStatus",
                text: "SndToHyStt",
                className: "sendToHybrisStatus",
                sortable: true,
                align: "left",
            },
            {
                key: "sendToHybrisAt",
                text: "SendToHybrisAt",
                className: "sendToHybrisAt",
                sortable: true,
                align: "left",
            },

        ];
        this.config = {
            key_column: 'codCatIte',
            page_size: 10,
            length_menu: [10, 20, 50],
            button: {
                excel: true,
                print: true,
                extra: true,
            },
            filename: "PrdCmb",

            language: {
                length_menu: "Mostrar _MENU_ registros por página",
                filter: "Buscar em registros ...",
                info: "Mostrando _START_ a _END_ de _TOTAL_ entradas",
                pagination: {
                    first: "Primeira",
                    previous: "Anterior",
                    next: "Próxima",
                    last: "Última"
                },
                loading_text: "Aguarde buscando informações..."
            }

        }

        this.extraButtons = [
            {
                className: "btn btn-success  ",
                title: "Exporta Selecionados",
                children: [
                    <img src={minhaImagemSelc} alt="" ></img>
                ],
                onClick: () => { this.ExportaSelecao(); },
            },
            {
                className: "btn btn-success ",
                title: "Exporta Todos",
                children: [
                    <img src={minhaImagemTodos} alt="" ></img>
                ],
                onClick: () => { this.ExportaTodos(); },
            },
        ]

        this.ExportaSelecao = this.ExportaSelecao.bind(this);
        this.ExportaTodos = this.ExportaTodos.bind(this);
        this.PopulartodosArrayEnviar = this.PopulartodosArrayEnviar.bind(this);
        this.setbscInf = this.setbscInf.bind(this);
        this.setPuxada = this.setPuxada.bind(this);

    }

    setPuxada(e) {
        this.setState({
            SelPuxada: (e.target.value === "" ? 0 : e.target.value)
            ,booLerRecords: false
        });
    }

    openModal = (qualfiltro) => {
        this.setState({ isModalOpen: qualfiltro });
    }
    closeModal = () => this.setState({ isModalOpen: 0, LimpaRegReposta: true })

    setbscInf() {
        if (this.state.SelPuxada === null || Number(this.state.SelPuxada) === 0) {
            toastr.warning("Atenção Selecione uma Revenda")
        }
        else {
            this.setState({
                MsgModal2: "Processando solicitação..."
            });
            this.openModal(2)
             this.props.getData(this.state.SelPuxada);
             setTimeout(() => {
                this.setState({
                booLerRecords: true
                , isModalOpen: 0
            });
        }, 500);
    }
    }

    PopulartodosArrayEnviar() {

        this.setState({
            todosArrayEnviar: []
        });

        if (this.props.redListaPrdCmb !== undefined && this.props.redListaPrdCmb !== null) {
            for (let i = 0, l = this.props.redListaPrdCmb.length; i < l; i++) {
                this.state.todosArrayEnviar.push(this.props.redListaPrdCmb[i].codCatIte);
            }
        }
    }

    selecionaCheck = (registro, record, index) => {

        const array1 = [];
        const array2 = [];
        let Existe = [{}];

        Existe = this.state.arrayMarcados
            .filter((a) => a.codCatIte === registro.codCatIte)

        if (Existe.length === 0) {
            this.state.arrayMarcados.push(registro)
            this.state.arrayEnviar.push(registro.codCatIte);
        }
        else {
            //Carrega Array1
            for (let i = 0, l = this.state.arrayMarcados.length; i < l; i++) {
                if (this.state.arrayMarcados[i].codCatIte !== registro.codCatIte) {
                    array1.push(this.state.arrayMarcados[i]);
                    array2.push(this.state.arrayMarcados[i].codCatIte);
                }
            }

            this.setState({
                arrayEnviar: array2
                , arrayMarcados: array1
            });

        }

    }

    ExportaSelecao() {
        if (this.state.arrayEnviar.length === 0) {
            toastr.warning("Não há seleção realizada !!!!")
        }
        else {
            this.setState({
                MsgModal2: "Enviando a solicitação... Será realizado em fila processamentos"
            });
            this.openModal(2)
            this.props.enviaRegistros(this.state.arrayEnviar
                , (this.props.codPuxada === undefined || this.props.codPuxada === null
                    ? this.state.SelPuxada : this.props.codPuxada)
                , this.props.nomeUsuario)
            setTimeout(() => {
                this.setState({
                    arrayMarcados: []
                    , arrayEnviar: []
                    , isModalOpen: 0
                });
            }, 4000);
        }

    }

    ExportaTodos() {

        this.PopulartodosArrayEnviar();

        let podeenviar = true;

        if (this.state.todosArrayEnviar.length === 0) {
            toastr.warning("Não há Combos a enviar !!!!")
            podeenviar = false
        }
        if (this.props.codPuxada === undefined || this.props.codPuxada === null) {
            if ( this.state.SelPuxada === undefined 
                    || this.state.SelPuxada === null  
                    || this.state.SelPuxada === 0) {
                toastr.warning("Revenda não selecionada !!!!")
                podeenviar = false;
            }
        }
 
        if (podeenviar === true) {
            this.setState({
                MsgModal2: "Enviando a solicitação... Será realizado em fila processamentos"
            });
            this.openModal(2)
            this.props.enviaRegistros(this.state.todosArrayEnviar
                , (this.props.codPuxada === undefined || this.props.codPuxada === null
                    ? this.state.SelPuxada : this.props.codPuxada)
                , this.props.nomeUsuario)
            setTimeout(() => {
                this.setState({
                    arrayMarcados: []
                    , arrayEnviar: []
                    , isModalOpen: 0
                });
            }, 4000);
        }
    }



    // editRecord(record) {
    //     console.log("Edit Record", record);
    // }

    // MrcDesRecord(event, record) {
    //     if (event.onChange){
    //         console.log("Edit Record: ", record);
    //         console.log("checked: ", event.onChange);

    //     }
    //     else
    //     {
    //         console.log("Edit Record: ", record);
    //         console.log("deschecked: ", event.onChange);
    //     }
    // }
    // MrcDesRecord = (e, record) => {
    //     console.log("Edit record: " + record);
    //     console.log("Selecao: " + (e.type === 'checkbox' ? e.checked : e.value));
    // }

    render() {
        const Listapuxadas = this.props.redListaTdsRevendas || [];

        return (

            <div className="container" >

                <div className="row">
                    <div className="Col">
                        <span className="cadastro-Externos">Inicial / &nbsp;
                            <span className="text-style-1">Products Combo</span>
                        </span>
                    </div>
                    <br />
                    <br />
                </div>

                <div className="row" style={{
                    display: (this.props.codPuxada === undefined || this.props.codPuxada === null ? "flex" : "none")
                    , fontSize: "18px", color: "#77b935", fontFamily: "Barlow"
                }}>
                    <div className="col">
                        <select id="Revenda"
                            value={this.state.SelPuxada}
                            onChange={this.setPuxada}
                        >
                            <option value="">-- Selecione Revenda --</option>
                            {Listapuxadas
                                .map((ar, i) => (
                                    <option key={i} value={ar.cod_puxada}>
                                        {ar.cod_puxada + " - " + ar.dsc_razaosocial}
                                    </option>
                                ))}
                        </select>
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        <button type="button"
                            style={{ fontSize: "18px", color: "#77b935" }}
                            data-toggle="tooltip"
                            title="Adiciona a Lista"
                            onClick={this.setbscInf}

                        >
                            <i className="fa fa-refresh " aria-hidden="true"></i>
                        </button>
                    </div>
                    <br />
                    <br />
                </div>

                <div className="row"
                    style={{
                        display: (this.props.codPuxada !== undefined && this.props.codPuxada !== null ? "flex" : "none")
                        , fontSize: "12px", color: "#77b935"
                    }}>
                    <div className="Col">
                        <span className="cadastro-Externos1">&nbsp;
                            <span>Código da Revenda: &nbsp; {(this.props.codPuxada === undefined || this.props.codPuxada === null ? 0 : this.props.codPuxada)}</span>
                        </span>
                    </div>
                    <br />
                    <br />
                </div>

                <div>
                    <ReactDatatable
                        config={this.config}

                        records={(this.state.booLerRecords === true ? this.props.redListaPrdCmb || [] : [])}
                        columns={this.columns}
                        extraButtons={this.extraButtons}
                    />
                </div>
                {/*Modal leitura*/}
                <Modal size="sm" show={(this.state.isModalOpen === 2 ? true : false)}
                    className="modal fade" role="dialog"
                    onHide={this.closeModal}

                >
                    <Modal.Body >
                        <div className="row d-flex justify-content-center" >
                            <Spinner animation="border" role="status" variant="success">
                            </Spinner>
                        </div>
                        <div className="row" style={{ textAlign: "Center" }}>
                            <i className="fa-blink "> {this.state.MsgModal2}</i>
                            {/* <span> {this.state.MsgModal2} </span> */}

                        </div>
                    </Modal.Body>

                </Modal>

            </div>
        )
    }
}
const mapStateToProps = state => (
    {
        nomeUsuario: state.authRed.NomUsuario
        , codPuxada: state.authRed.CodPuxada
        , TipoLicenca: state.authRed.TipoUsuario
        , redListaTdsRevendas: state.prdCmbRedJS.ListaTdsRevendas
        , redListaPrdCmb: state.prdCmbRedJS.listaPrdCmb
    }
)
const mapDispatchToProps = dispatch => bindActionCreators(
    {
        getData
        , enviaRegistros
        , logout
        , getDataTdsRevendas
    }
    , dispatch)

export default connect(mapStateToProps, mapDispatchToProps)(PrdCmb)